export function initForm() {
  const form = document.querySelector('form.contact-form, .contact-form form');
  if (!form || form.tagName !== 'FORM') return;
  if (form.classList.contains('brxe-form')) return;

  const status = form.querySelector('.contact-form__status');
  const theme = window.ambidryTheme || {};

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    status.classList.remove('is-error', 'is-success');

    if (!form.checkValidity()) {
      status.textContent = 'Please complete the required fields.';
      status.classList.add('is-error');
      form.reportValidity();
      return;
    }

    const data = new FormData(form);
    data.append('action', 'ambidry_contact');
    data.append('nonce', theme.nonce || '');

    try {
      const response = await fetch(theme.ajaxUrl || '/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
      });
      const json = await response.json();
      if (!response.ok || !json.success) {
        throw new Error(json?.data?.message || 'Unable to send right now.');
      }
      status.textContent = json.data.message;
      status.classList.add('is-success');
      form.reset();
    } catch (error) {
      status.textContent = error.message || 'Unable to send right now.';
      status.classList.add('is-error');
    }
  });
}
